module.exports = __webpack_public_path__ + "img/BD_attachement.9888af7a.png";